
import React from 'react';
import { Navigate } from 'react-router-dom';
import Layout from './Layout';

const ProtectedRoute = ({ token, onLogout, themeMode, toggleTheme, children }) => {
  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout onLogout={onLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
      {children}
    </Layout>
  );
};

export default ProtectedRoute;
